import React from 'react';
import { useNavigate } from 'react-router-dom';

function InsightsPage() {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <button onClick={handleBack} style={styles.backButton}>← Back to Home</button>
        <h2 style={styles.heading}>Parent School Dashboard</h2>
      </div>
      <iframe
        title="Parent School Dashboard"
        src="https://lookerstudio.google.com/embed/reporting/2ad6bffc-d382-42ae-ba1b-efa81cc5c4ff/page/XuMIF"
        style={styles.iframe}
        allowFullScreen
      ></iframe>
    </div>
  );
}

const styles = {
  container: {
    width: '100%',
    height: '100dvh',
    margin: 0,
    padding: 0,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    padding: '0.5rem 1rem',
    backgroundColor: '#f5f5f5',
    borderBottom: '1px solid #ddd',
  },
  backButton: {
    marginRight: 'auto',
    backgroundColor: '#4285f4',
    color: 'white',
    border: 'none',
    padding: '0.4rem 0.8rem',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '0.9rem',
  },
  heading: {
    fontSize: '1.1rem',
    margin: 0,
    textAlign: 'center',
    flex: 1,
  },
  iframe: {
    flex: 1,
    width: '100%',
    border: 'none',
  },
};

export default InsightsPage;
